"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
class StringUtils {
    static isNonEmptyString(s) {
        if (!s)
            return false;
        return typeof s === 'string';
    }
    static isNullishOrNonEmptyString(s) {
        // allow `null` and `undefined`
        if (s === null || s === undefined)
            return true;
        return this.isNonEmptyString(s);
    }
}
exports.StringUtils = StringUtils;
//# sourceMappingURL=StringUtils.js.map